module.exports = __webpack_public_path__ + "img/apply-filter-icon.2535096f.svg";